import React, { useState } from 'react';
import './profile.scss';
import Form from 'devextreme-react/form';
import {useAuth} from "../../contexts/auth";

export default function Profile() {
  const {user} = useAuth();
  const [notes, setNotes] = useState(
    'Your active directory profile information. Ready only.'
  );
  const employee = {
    id: user.id,
    name: user.name,
    email: user.email,
    created: user.created,
  };

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Profile</h2>

      <div className={'content-block dx-card responsive-paddings'}>
        <div className={'form-avatar'}>
          <img
            alt={''}
            src={user.avatarUrl}
          />
        </div>
        <span>{notes}</span>
      </div>

      <div className={'content-block dx-card responsive-paddings'}>
        <Form
          id={'form'}
          defaultFormData={employee}
          onFieldDataChanged={e => e.dataField === 'Notes' && setNotes(e.value)}
          labelLocation={'top'}
          colCountByScreen={colCountByScreen}
        />
      </div>
    </React.Fragment>
  );
}

const colCountByScreen = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4
};
